import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { commonRoutes } from "./route"



export const routes: Array<RouteRecordRaw> = [...commonRoutes]


const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({
    top: 0
  }),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
	if (to.path === '/login' && !token) {
		next();
	} else {
		if (!token) {
			next('/login');
		} else if (token && to.path === '/login') {
			next('/home');
		} else {
			next();
		}
	}
})

export default router
